import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'giftCard.lifetime.purchaseForm.heading',
		defaultMessage: 'The Gift of a Lifetime',
		description: 'Heading for the lifetime gift card purchase form',
	},
	bullet1: {
		id: 'giftCard.lifetime.purchaseForm.bullet1',
		defaultMessage: 'Get 60% off Lifetime of Calm Premium',
		description: 'Bullet point telling user discount',
	},
	bullet2: {
		id: 'giftCard.lifetime.purchaseForm.bullet2',
		defaultMessage: 'Improve sleep and mindfulness—for life',
		description: 'Benefit of purchasing a lifetime gift card',
	},
	bullet3: {
		id: 'giftCard.lifetime.purchaseForm.bullet3',
		defaultMessage: 'Exclusive, limited time offer',
		description: 'Limited time offer copy',
	},
});
